import { render, staticRenderFns } from "./page8Exit.vue?vue&type=template&id=f46d6432"
import script from "./page8Exit.vue?vue&type=script&lang=js"
export * from "./page8Exit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports